<script lang="ts" setup></script>

<template>
   <RouterView></RouterView>
</template>
